module.exports = __webpack_public_path__ + "static/truth-social-logo-2eb9b83760c803d8a312010e65b8a88f.svg";